import { style, styleVariants } from '../layer.css.ts';
import { hairline } from '../theme-v2/hairline.ts';
import { themeV2 } from '../theme-v2/vars.ts';
import { borderRadius, fonts, fontWeight, space } from '../tokens';

export const badgeV2 = style({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: space.s4,
  padding: `${space.s4}px ${space.s12}px`,
  borderRadius: borderRadius.r64,
  fontFamily: fonts.mono,
  fontWeight: fontWeight.medium,
  fontSize: 12,
  lineHeight: 1.4,
  letterSpacing: '-0.04em',
  whiteSpace: 'nowrap',
});

export const badgeV2Tones = styleVariants({
  data: {
    backgroundColor: 'rgba(177, 169, 205, 0.2)',
    boxShadow: hairline(themeV2.color.border.subtle),
    color: '#c9bfec',
  },
  custom: {
    backgroundColor: 'rgba(199, 171, 92, 0.3)',
    boxShadow: hairline('rgba(190, 163, 88, 0.05)'),
    color: '#bea358',
  },
  package: {
    backgroundColor: 'rgba(114, 175, 231, 0.3)',
    boxShadow: hairline('rgba(114, 175, 231, 0.05)'),
    color: '#72afe7',
  },
  tag: {
    backgroundColor: 'transparent',
    boxShadow: hairline(themeV2.color.border.subtle),
    color: themeV2.color.text.quaternary,
  },
});
